/**
 * Validator - Is JSON
 *
 * Checks whether `value` can be parsed as a JSON.
 *
 * @param {string} value - value to validate
 * @param {Object} options - validator options
 * @returns {string} value - validated value
 */
export default (value, options) => {
  try {
    value && JSON.parse(value)
    return value
  } catch (e) {
    const { error } = options
    throw TypeError(error)
  }
}
